import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface SendIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const SendIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick,
}: SendIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 9.41177L19 5L14.5882 20L11.0588 12.9412L4 9.41177Z"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11 13L19 5"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    )
}

export default SendIcon
